import { api } from "./api";

// BELL2 · 顶部铃铛阶段 2「动态」段 · 对齐 apps/api-server/.../routes/admin_notifications.py
export interface AdminNotificationItem {
  id: string;
  severity: "info" | "warning" | "critical";
  title: string;
  body: string | null;
  deeplink: string | null;
  source_code: string;
  created_at: string;
  is_read: boolean;
}

export interface AdminNotificationListResponse {
  items: AdminNotificationItem[];
  total: number;
  unread_count: number;
  page: number;
  page_size: number;
}

export const adminNotificationsApi = {
  list: (page = 1, pageSize = 20) =>
    api<AdminNotificationListResponse>(
      `/api/v1/admin-notifications?page=${page}&page_size=${pageSize}`,
    ),
  markRead: (id: string) =>
    api<AdminNotificationItem>(`/api/v1/admin-notifications/${id}/read`, { method: "POST" }),
  markAllRead: () =>
    api<{ updated: number }>("/api/v1/admin-notifications/read-all", { method: "POST" }),
};
